import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setAuth } from "../adminApi";

// Port of admin/superadmin.php
export default function SuperadminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (password === "milesplay") {
      setAuth({ sessionId: "admin", organizationId: "admin" });
      sessionStorage.setItem("adminSuperLogin", "1"); // marks this tab as a superadmin tab
      navigate("/admin/themes");
    } else {
      setError("Incorrect password");
    }
  };

  return (
    <div className="LoginPage_container">
      <form className="LoginPage_form" onSubmit={submit}>
        <h2 className="LoginPage_title">Superadmin Login</h2>
        {error && <div className="LoginPage_error">{error}</div>}
        <div className="LoginPage_field">
          <label className="LoginPage_label" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            className="LoginPage_input"
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="LoginPage_button">
          Login
        </button>
      </form>
    </div>
  );
}
